import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { DelugeVortexTutorialState } from './DelugeTutorialAdapter.js';

type VState = DelugeVortexTutorialState;

const PARTIAL = 'D,A3fB2fC2bB1b';
const PARTIAL_GATED = `${PARTIAL}|B3=C0`;
const SOLVED = 'D,A3fB2fC2bB1bD2fD1b|B3=C0';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { deluge: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'D5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { deluge: PARTIAL },
                { deluge: PARTIAL, gateMode: true },
                { deluge: PARTIAL_GATED, gateMode: true },
                { deluge: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle an unblocked pair active; a blocked pair stays amber
    {
        gameState: { deluge: 'DB5f', gateMode: true, extraGates: [['B5', 'D5']] } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'C2', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Walls block\ngate activation', cell: 'B5', anchor: 'far-above', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { deluge: 'DB5f', gateMode: true, extraGates: [['B5', 'D5']] },
                { deluge: 'DB5f|B3=C0', gateMode: true, extraGates: [['B5', 'D5']] },
            ] as VState[],
        },
    },

    // Scene 3: Water teleportation
    {
        gameState: { deluge: PARTIAL_GATED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Water enters\na gate...', cell: 'B3', anchor: 'far-right' },
            { type: 'text-label', text: '...exits from\nthe other side', cell: 'C0', anchor: 'far-right' },
            { type: 'pulse', cell: 'B3', color: COLORS.purple },
            { type: 'pulse', cell: 'C0', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { deluge: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Do not worry\nabout loops', cell: 'D3', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'B3', color: COLORS.purple },
            { type: 'pulse', cell: 'C0', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Deluge tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches water teleportation through Vortex gates.
 */
export const DELUGE_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'deluge-vortex',
    gridCode: '6/0-3:0C4,1C1,2A2,3F3',
    scenes,
    previewScene: 3,
};
